module.exports = __webpack_public_path__ + "img/MS.f9232990.png";